
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects/[project]",
      function () {
        return require("private-next-pages/projects/[project].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projects/[project]"])
      });
    }
  